function AppNavController($state) {
	var vm = this;

	vm.pagina = $state.current.name;
}

angular
	.module('common')
	.controller('AppNavController', AppNavController);
